import { getArea, getFid } from "./plot-utils";

export const transformInvestmentOpportunities = (
  allFeatures: any[],
  dictionaries: any,
) => {
  return allFeatures.map((item) =>
    transformInvestmentOpportunity(item, dictionaries),
  );
};
export const transformInvestmentOpportunity = (
  item: any,
  dictionaries: any,
) => {
  return {
    number: item.PlotNum,
    area: Math.round(getArea(item)).toString(),
    city: dictionaries["estateEn"]?.[item.estateEn] || item.estateEn,
    cityId: item.estateID,
    landUseId: item.Landuse,
    typeOfUse: dictionaries["Landuse"]?.[item.Landuse] || item.Landuse,
    invOpNameAr: item.InOp_nam_a?.trim(),
    invOpNameEn: item.InOp_nam_e?.trim(),
    fid: getFid(item).toString(),
    status: item.status,
    geometry: item.geometry,
    layer: item.layer,
    objectId: item.objectId,
    estateAr: dictionaries["estateAr"]?.[item.estateAr] || item.estateAr,
    estateEn: item.estateEn,
    prodtype_e: item.prodtype_e,
    tenant_id: item.tenant_id,
    type: "InvestmentOpportunities",
    is_inv_op: item.is_inv_op,
  };
};

export const transformPlots = (allFeatures: any[], dictionaries: any) => {
  return allFeatures.map((plot) => transformPlot(plot, dictionaries));
};

export const transformPlot = (plot: any, dictionaries: any) => {
  const fullLocationStatus =
    dictionaries["location_status_code"]?.[plot.location_status_code] ||
    plot.location_status_code;
  const englishLocationStatus =
    fullLocationStatus?.split("-")[0].trim() || fullLocationStatus;
  return {
    number: plot.PlotNum,
    area: Math.round(getArea(plot)).toString(),
    locationStatusCode: englishLocationStatus,
    city: dictionaries["estateEn"]?.[plot.estateEn] || plot.estateEn,
    cityId: plot.estateID,
    fid: getFid(plot),
    status: plot.status,
    landUseId: plot.Landuse,
    typeOfUse: dictionaries["Landuse"]?.[plot.Landuse] || plot.Landuse,
    geometry: plot.geometry,
    layer: plot.layer,
    objectId: plot.objectId,
    estateAr: dictionaries["estateAr"]?.[plot.estateAr] || plot.estateAr,
    phase:
      dictionaries["parent_location_Serial"]?.[plot.parent_location_Serial] ||
      plot.parent_location_Serial,
    phaseId: plot.parent_location_Serial,
    estateEn: plot.estateEn,
    prodtype_e: plot.prodtype_e,
    tenant_id: plot.tenant_id,
    type: "Plots",
    is_inv_op: plot.is_inv_op,
  };
};

export const transformSpacesForRent = (
  allFeatures: any[],
  citiesMapEn: Map<number, string>,
  citiesMapAr: Map<number, string>,
) => {
  return allFeatures.map((space) => ({
    number: space["Office_Num"] ?? space["OfficeNum"],
    city: citiesMapEn.get(space.estateid),
    cityId: space.estateid,
    building: space.Building_e,
    status: space.status,
    typeOfUse: space.landuse_e,
    fid: (
      space["KOM_DBO_Spaces_fid"] ??
      space["DBO.KOM_Office_Spaces_40.fid"] ??
      ""
    ).toString(),
    layer: space.layer,
    floorName: space.estate_e,
    area: Math.round(space.Shape__Area).toString(),
    estateId: space.estateid,
    objectId: space.objectId,
    estateAr: citiesMapAr.get(space.estateid),
    geometry: space.geometry,
    is_inv_lan: space["is_inv_lan"] ?? space["Invest"],
    estateEn: space.estateid,
    prodtype_e: space.prodtype_e,
    tenant_id: space.tenant_id,
    type: "SpacesForRent",
  }));
};
